import { c as _c } from "react/compiler-runtime";
import { selectedCompanyContextSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { hasUserValidFeatureCompanyLevel } from "@utils/feature-control/company/company-feature-control";
import { RequiredFeatureCompanyLevelName } from "@utils/feature-control/company/company-feature-control-types";
import { useCallback, useMemo } from "react";
/** Checks whether a user has permission for an action on company level or not */
export function useHasUserValidFeatureCompanyLevel(t0) {
  const $ = _c(45);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    featuresAvailable: t2
  } = t1;
  const featuresAvailable = t2 === undefined ? undefined : t2;
  const companyContext = useAppSelector(selectedCompanyContextSelector);
  companyContext?.featuresAvailable;
  const availableFeatures = featuresAvailable ?? companyContext?.featuresAvailable;
  let t3;
  if ($[2] !== availableFeatures) {
    t3 = hasUserValidFeatureCompanyLevel({
      featureName: RequiredFeatureCompanyLevelName.canViewCompanyGroups,
      featuresAvailable: availableFeatures
    });
    $[2] = availableFeatures;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const canViewCompanyGroups = t3;
  let t4;
  if ($[4] !== availableFeatures) {
    t4 = hasUserValidFeatureCompanyLevel({
      featureName: RequiredFeatureCompanyLevelName.canViewCompanyMembers,
      featuresAvailable: availableFeatures
    });
    $[4] = availableFeatures;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const canViewCompanyMembers = t4;
  let t5;
  if ($[6] !== availableFeatures) {
    t5 = hasUserValidFeatureCompanyLevel({
      featureName: RequiredFeatureCompanyLevelName.canViewProjects,
      featuresAvailable: availableFeatures
    });
    $[6] = availableFeatures;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const canViewProjects = t5;
  let t6;
  if ($[8] !== availableFeatures) {
    t6 = hasUserValidFeatureCompanyLevel({
      featureName: RequiredFeatureCompanyLevelName.canCreateProjects,
      featuresAvailable: availableFeatures
    });
    $[8] = availableFeatures;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const canCreateProjects = t6;
  let t7;
  if ($[10] !== availableFeatures) {
    t7 = hasUserValidFeatureCompanyLevel({
      featureName: RequiredFeatureCompanyLevelName.canViewAnalytics,
      featuresAvailable: availableFeatures
    });
    $[10] = availableFeatures;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const canViewAnalytics = t7;
  let t8;
  if ($[12] !== availableFeatures) {
    t8 = hasUserValidFeatureCompanyLevel({
      featureName: RequiredFeatureCompanyLevelName.canViewPremiumAnalytics,
      featuresAvailable: availableFeatures
    });
    $[12] = availableFeatures;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const canViewPremiumAnalytics = t8;
  let t9;
  if ($[14] !== availableFeatures) {
    t9 = hasUserValidFeatureCompanyLevel({
      featureName: RequiredFeatureCompanyLevelName.canViewIntegrations,
      featuresAvailable: availableFeatures
    });
    $[14] = availableFeatures;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const canViewIntegrations = t9;
  let t10;
  if ($[16] !== availableFeatures) {
    t10 = hasUserValidFeatureCompanyLevel({
      featureName: RequiredFeatureCompanyLevelName.canViewWorkspaceSettings,
      featuresAvailable: availableFeatures
    });
    $[16] = availableFeatures;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const canViewWorkspaceSettings = t10;
  let t11;
  if ($[18] !== availableFeatures) {
    t11 = hasUserValidFeatureCompanyLevel({
      featureName: RequiredFeatureCompanyLevelName.canExportWorkspace,
      featuresAvailable: availableFeatures
    });
    $[18] = availableFeatures;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const canExportWorkspace = t11;
  let t12;
  if ($[20] !== availableFeatures) {
    t12 = hasUserValidFeatureCompanyLevel({
      featureName: RequiredFeatureCompanyLevelName.canUseTeams,
      featuresAvailable: availableFeatures
    });
    $[20] = availableFeatures;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const canUseTeams = t12;
  let t13;
  if ($[22] !== availableFeatures) {
    t13 = hasUserValidFeatureCompanyLevel({
      featureName: RequiredFeatureCompanyLevelName.canAssignProjectRoles,
      featuresAvailable: availableFeatures
    });
    $[22] = availableFeatures;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const canAssignProjectRoles = t13;
  let t14;
  if ($[24] !== availableFeatures) {
    t14 = hasUserValidFeatureCompanyLevel({
      featureName: RequiredFeatureCompanyLevelName.canAssignManagers,
      featuresAvailable: availableFeatures
    });
    $[24] = availableFeatures;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const canAssignManagers = t14;
  let t15;
  if ($[26] !== availableFeatures) {
    t15 = hasUserValidFeatureCompanyLevel({
      featureName: RequiredFeatureCompanyLevelName.isHbToSxgMigrated,
      featuresAvailable: availableFeatures
    });
    $[26] = availableFeatures;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  const isHbToSxgMigrated = t15;
  let t16;
  if ($[28] !== availableFeatures) {
    t16 = t17 => {
      const {
        featureName,
        featuresAvailable: featuresAvailable_0
      } = t17;
      return hasUserValidFeatureCompanyLevel({
        featureName,
        featuresAvailable: featuresAvailable_0 ?? availableFeatures
      });
    };
    $[28] = availableFeatures;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const hasFeatureCompanyLevel = t16;
  let t17;
  if ($[30] !== canAssignManagers || $[31] !== canAssignProjectRoles || $[32] !== canCreateProjects || $[33] !== canExportWorkspace || $[34] !== canUseTeams || $[35] !== canViewAnalytics || $[36] !== canViewCompanyGroups || $[37] !== canViewCompanyMembers || $[38] !== canViewIntegrations || $[39] !== canViewPremiumAnalytics || $[40] !== canViewProjects || $[41] !== canViewWorkspaceSettings || $[42] !== hasFeatureCompanyLevel || $[43] !== isHbToSxgMigrated) {
    t17 = {
      canViewCompanyGroups,
      canViewCompanyMembers,
      canViewProjects,
      canCreateProjects,
      canViewAnalytics,
      canViewPremiumAnalytics,
      canViewIntegrations,
      canViewWorkspaceSettings,
      canExportWorkspace,
      canUseTeams,
      canAssignProjectRoles,
      canAssignManagers,
      isHbToSxgMigrated,
      hasFeatureCompanyLevel
    };
    $[30] = canAssignManagers;
    $[31] = canAssignProjectRoles;
    $[32] = canCreateProjects;
    $[33] = canExportWorkspace;
    $[34] = canUseTeams;
    $[35] = canViewAnalytics;
    $[36] = canViewCompanyGroups;
    $[37] = canViewCompanyMembers;
    $[38] = canViewIntegrations;
    $[39] = canViewPremiumAnalytics;
    $[40] = canViewProjects;
    $[41] = canViewWorkspaceSettings;
    $[42] = hasFeatureCompanyLevel;
    $[43] = isHbToSxgMigrated;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  return t17;
}